import React, {useEffect, useState} from 'react';
import TransactionDetailsAPI from "../api/TransactionDetailsAPI";
import {Center, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Text} from "@chakra-ui/react";
import useCommonAPI from "../api/CommonAPI";
import {setActionPayload, setActionType} from "../features/authorizationSlice";
import {ACTION_TYPES} from "../app/actionTypes";
import {useDispatch} from "react-redux";
import {useOutletContext} from "react-router-dom";
import BlurLoading from "./BlurLoading";
import {formatCurrency} from "../features/ValueFormater";

function RepeatTransaction({transactionID, modalOpen, setModalOpen}) {
    const {GetTransactionDetails, transactionDetails} = TransactionDetailsAPI();
    const {getAllCurrencies} = useCommonAPI();

    const [onOpenQrAfterGenerate] = useOutletContext();
    const dispatch = useDispatch();

    const [selectedFile, setSelectedFile] = useState();
    const [error, setError] = useState("");
    const [file, setFile] = useState({});


    useEffect(() => {
        transactionID &&
        GetTransactionDetails(transactionID);
        getAllCurrencies();
    }, [transactionID]);

    useEffect(() => {
        if (selectedFile) {

            const fileSizeLimit = 2 * 1024 * 1024; // 2 MB
            if (selectedFile && selectedFile.size > fileSizeLimit) {
                setError("File should not be larger than 2MB.");
            } else {
                setError("");
            }

            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onloadend = () => {
                const base64String = reader.result;
                setFile({
                    ReasonFileName: selectedFile.name,
                    ReasonFile: base64String
                });
            };

        }
    }, [selectedFile]);

    // if file is required
    // const validateForm = () => {
    //     let isValid = true;
    //
    //     if (selectedFile === undefined || selectedFile.name === undefined || selectedFile.size <= 0) {
    //         setError("File upload is required.");
    //         isValid = false;
    //     }
    //
    //     return isValid;
    // }

    const handleRepeatTransfer = (type) => {
        setModalOpen(true);
    }

    const handleConfirm = () => {
        // if (validateForm()) {}
        if (!error) {
            setModalOpen(false)
            const [currency, value] = transactionDetails.Amount.split(" ");

            const payload = {
                CurrencyID: transactionDetails.CurrencyID,
                BeneficiaryName: transactionDetails.BeneficiaryName || transactionDetails.RecipientName,
                IBAN: transactionDetails.IBAN ?? null,
                PhoneNo: transactionDetails.RecipientMobileNo ?? null,
                Amount: value,
                ReasonOfTransfer: transactionDetails.ReasonForTransfer,
                ReasonFileName: file.ReasonFileName,
                ReasonFile: file.ReasonFile,
            }

            if (transactionDetails.IBAN) {
                dispatch(setActionType(ACTION_TYPES.PUSH_BANK_TRANSFER));
                dispatch(setActionPayload(payload));

                onOpenQrAfterGenerate();
            }
            if (transactionDetails.RecipientMobileNo) {
                dispatch(setActionType(ACTION_TYPES.PUSH_S2S_TRANSFER));
                dispatch(setActionPayload(payload));

                onOpenQrAfterGenerate();
            }
        }
    }

    return (
        <div>
            <Modal isCentered isOpen={modalOpen} onClose={() => {
                setModalOpen(false);
            }
            }>
                <ModalOverlay/>
                <ModalContent>
                    <ModalHeader textAlign='center' textTransform='uppercase'>
                        <div className="modal-header-image">
                            {<img src="Images/caution.png" alt=""/>}
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <Center>
                            <Text textAlign='center' fontSize={16} fontFamily={"Poppins Bold"} color={"#495666"}>
                                Repeat Transfer
                            </Text>
                        </Center>
                        <Center>
                            <Text textAlign='center' fontSize={25} fontFamily={"Poppins SemiBold"} color={"#495666"}>
                                {formatCurrency(transactionDetails.Amount)}
                            </Text>
                        </Center>
                        <div className="modalAccountValues">

                            <div className="row">
                                <div className="col-6 label">From Account</div>
                                <div
                                    className="col-6 value">{transactionDetails.IBAN || transactionDetails.RecipientMobileNo}</div>
                            </div>
                            <div className="row beneficiary-title">
                                <div className="col-8">Beneficiary Information</div>
                            </div>
                            <div className="row merch-info">
                                <div className="col-5 label">Beneficiary Name</div>
                                {(transactionDetails.BeneficiaryName || transactionDetails.RecipientName) &&
                                    <div className="col-6">
                                        {
                                            transactionDetails.BeneficiaryName &&
                                            <div className="value">{transactionDetails.BeneficiaryName}</div>
                                        }
                                        {
                                            transactionDetails.RecipientName &&
                                            <div className="value">{transactionDetails.RecipientName}</div>
                                        }
                                    </div>
                                }
                            </div>
                            <div className="row">
                                <div className="col-5 label">Upload File</div>
                                <div className="col-6 component">
                                    <input type="file" id="repeatFile" name="ReasonFile"
                                           onClick={() => {
                                               setError("");
                                           }}
                                           onChange={
                                               (e) => {
                                                   setSelectedFile(e.target.files[0])
                                               }
                                           }/>
                                    {error && (
                                        <span className="error m-0">{error}</span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <Center>
                            <div className=" modal-footer mb-3">
                                <button
                                    id="closeTransferModalBtn"
                                    onClick={() => {
                                        setModalOpen(false);
                                    }}
                                >
                                    Not Now
                                </button>
                                <button
                                    id="closeModalBtn"
                                    onClick={() => {
                                        handleConfirm();
                                    }}
                                >
                                    Repeat Payment
                                </button>
                            </div>

                        </Center>

                    </ModalBody>
                </ModalContent>
            </Modal>
            <BlurLoading/>
        </div>
    );
}

export default RepeatTransaction;